import { selectPolicies } from '@v2/domains/user/selectors/user.selectors'
import { useAppSelector } from '@v2/store/hooks'

const usePolicyVerification = (policy: string) => {
  const policies = useAppSelector(selectPolicies)
  return policies.includes(policy)
}

export default usePolicyVerification
